import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight, LogIn } from "lucide-react";
import { Logo } from "@/components/Logo";
import { scrollToId } from "@/components/Reveal";

const LINKS = [
  { id: "nav-link-features", label: "Özellikler", target: "#ozellikler" },
  { id: "nav-link-demo", label: "Canlı Demo", target: "#demo" },
  { id: "nav-link-pricing", label: "Fiyatlandırma", target: "#fiyatlandirma" },
  { id: "nav-link-faq", label: "SSS", target: "#erken-erisim" },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="main-header"
      initial={{ y: -64, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "glass-panel border-b border-white/10"
          : "border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-12">
        <button
          data-testid="nav-logo"
          onClick={() => window.__lenis?.scrollTo(0)}
          className="outline-none"
          aria-label="Akış ana sayfa"
        >
          <Logo />
        </button>

        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((link) => (
            <button
              key={link.id}
              data-testid={link.id}
              onClick={() => scrollToId(link.target)}
              className="text-sm font-medium text-slate-400 transition-colors duration-300 hover:text-emerald-400"
            >
              {link.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-4">
          <Link
            to="/giris"
            data-testid="nav-login-link"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-300 transition-colors duration-300 hover:text-emerald-400"
          >
            <LogIn className="h-4 w-4" />{" "}
            <span className="hidden sm:inline">Giriş Yap</span>
          </Link>
          <button
            data-testid="nav-cta-early-access"
            onClick={() => scrollToId("#erken-erisim")}
            className="group inline-flex items-center gap-1.5 rounded-full bg-emerald-500 px-5 py-2.5 text-sm font-semibold text-emerald-950 transition-all duration-300 hover:bg-emerald-400 hover:shadow-[0_0_28px_rgba(0,255,135,0.35)]"
          >
            Erken Erişim Al
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;
